import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  GroupLogo: {
    height: "calc(100% - 2px)",
    marginTop: 1,
    width: "auto",
    borderRadius: "4px",
    background: p => p.backgroundColor || null,
    padding: p => (p.backgroundColor ? 2 : null),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    boxSizing: "border-box"
  },
  noLogoRoot: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    // background: theme.palette.neutral,
    paddingLeft: 5,
    paddingRight: 5,
    borderRadius: "4px"
  },
  noLogoTypo: {
    maxHeight: "100%",
    height: "auto",
    width: "auto",
    // color: theme.palette.getContrastText(theme.palette.neutral)
  }
}));
